export default {
  bank_account_status: '账户审核状态',
  delete_account: '删除账户',
  confirm_delete: '确认删除',
  bank_account_holder: '账户持有人',
  bank_account_list: '银行账户列表',
  bank_wallet: '存折首页/钱包',
  add_new_bank_account: '添加银行账户',
  cash_out_settng: '提现设置',
  online_banking: '线上网银充值',
  offline_check: '线下充值（支票）',
  offline_cash: '线下充值（现金）',
  qr_payment: 'QR支付',
  thai_qr_payment: 'Thai QR 支付',
  payment_type: '充值类型',
  upload_receipt: '上传凭证',
  upload_receipt_required: '上传凭证 (必填）',
  upload_receipt_tip: '最多上传五张图片',
  balance_details: '余额明细',
  recharge_record: '充值记录',
  withdraw_record: '提现记录',
  nsds_bill: 'NSDS账单',
  Transfer_Record: '转账记录',
  balance: '余额',
  payment_account: '出款账户',
  fixed_amount: '固定金额',
  reverse: '冲正',
  payee_information: '收款人信息',
  select_bank: '选择银行',
  top_up: '充值',
  cash_out: '提现',
  cashout_fail: '提现失败',
  next_cash_out_date: '下一个提现日',
  withdrawal_period: '提现周期',
  withdraw_success_tip: '提现申请已经提交，等待银行处理',
  recharge_success_tip: '还需要你用银行卡转账。',
  qr_tip_1: '充值订单将会在',
  thai_qr_tip_1: '充值订单将会在',
  one_hour: '1h',
  qr_tip_2: '后过期，请尽快支付',
  thai_qr_tip_2: '后过期，请尽快支付',
  successfully_submit: '提交成功',
  successfully_cash_out: '成功提现',
  name: '名称',
  account: '账户',
  mobile: '手机号',
  total_amount: '金额汇总',
  total_fee: '费用汇总',
  total_count: '笔数汇总',
  remark: '备注',
  related_merchants: '关联商户',
  transfer: '转账',
  transfer_amount: '转账金额',
  transfer_time: '转账时间',
  action_type: '转账类型',
  amount: '金额',
  deposit_no: '存款编号',
  associated_merchant_id: '关联商户ID',
  associated_merchant_name: '关联商户名称',
  transfer_in_merchant_no: '转入商户编号',
  transfer_out_merchant_no: '转出商户编号',
  recharge_tip: '转账至此账户，并保存回执',
  loan_amount: '付款金额',
  loan_number: '付款笔数',
  loan_fee: '付款费用',
  loan_commission: '付款佣金',
  collection_amount: '收款金额',
  collection_number: '收款笔数',
  collection_fee: '收款费用',
  collection_commission: '收款佣金',
  total_loan_amount: '总付款金额',
  total_loan_number: '总付款笔数',
  total_loan_fee: '总付款费用',
  total_collection_amount: '总收款金额',
  total_collection_number: '总收款笔数',
  total_collection_fee: '总收款费用',
  monthly_summary: '本月度汇总',
  last_monthly_summary: '上月度汇总',
  real_time_settlement_amount: '实时结算金额',
  frozen_amount: '冻结金额',
  unfrozen_amount: '解冻金额',
  postpone_amount: '收单结算',
  summary_details: '详情汇总',
  creation: '创建',
  submission: '提交',
  step: '步骤',
  bank_details: '银行详情',
  company_address: '公司地址',
  enter_top_up_amount: '输入充值金额',
  amount_details: '金额详情',
  transfer_details: '转账详情',
  sender: '发送方',
  receiver: '接收方',
  fee: '交易费用',
  transactions_summary: '交易汇总',
  total_transaction_details: '总交易详情',
  filter_section: '筛选',
  payin_transaction: '收款交易',
  payout_transaction: '付款交易',
  refund_transaction: '退款交易',
  loan_transaction: '借款交易',
  repayment_transaction: '还款交易',
  timeline: '时间',
  paid: '交易金额',
  description: '详情',
  payin_details: '收款详情',
  payout_details: '付款详情',
  refund_details: '退款详情',
  loan_detail: '借款详情',
  payin_created: '创建收款',
  payin_completed: '完成收款',
  payout_created: '创建付款',
  payout_completed: '完成付款',
  resend_notice: '重试通知',
  download_details: '凭证下载',
  download_time: '下载时间',
  payment_method_channel: '支付方式/渠道',
  currency: '币种',
  transaction_currency: '交易币种',
  top_up_currency: '充值币种',
  usd_amount: '美元金额',
  php_amount: '比索金额',
  mxn_amount: '比索金额',
  abnormal_adjustment: '差错调整',
  abnormal_adjustment_credit_balance: '差错调整入金（余额）',
  abnormal_adjustment_credit_frozen: '差错调整入金（冻结金额）',
  abnormal_adjustment_debit_balance: '差错调整出金（余额）',
  abnormal_adjustment_debit_frozen: '差错调整出金（冻结金额）',
  frozen_amount_balance: '冻结余额',
  total_commission: '佣金汇总',
  commission: '佣金',
  remitting_bank: '汇款银行',
  remitting_account: '汇款账号',
  settlement_status: '结算状态',
  estimated_settlement_time: '预计结算时间',
  actual_settlement_time: '实际结算时间',
  fail_reason: '失败原因',
  initiate_refund: '发起退款',
  full_refund: '全部退款',
  partial_refund: '部分退款',
  refund_amount: '退款金额',
  refunded_transaction_fee: '退回手续费金额',
  refund_number: '退款笔数',
  refund_amount_fail: '支付退款失败金额',
  back_to_balance: '返回账户余额',
  recharge_step_1_title: '步骤1： 选择银行',
  recharge_step_2_title: '步骤2： 充值详情',
  cash_out_amount: '提现金额',
  top_up_amount: '充值金额',
  scan_qr_code: '扫描二维码',
  refresh: '刷新',
  proceed_to_payment: '去支付',
  cash_out_amount_should: '提现金额应',
  minimum_cash_out_amount: '最低提现金额',
  pending_for_settlement: '支付成功待T+1日入账',
  exchange_rate: '汇率',
  buy_currency: '买入币种',
  buy_amount: '买入金额',
  sell_currency: '卖出币种',
  sell_amount: '卖出金额',
  destination_amount: '到账金额',
  source_amount: '付款金额',
  quote_id: '报价编号',
  exchange_transaction_id: '换汇单号',
  fx_transaction_type: '换汇交易类型',
  base_currency: '基础币种',
  quote_currency: '报价币种',
  quote_time: '报价时间',
  quote_expiry_time: '报价过期时间',
  related_transactions: '关联交易',
  document_proof: '证明文件',
  fx_transfer_out_fee: '换汇转出手续费',
  fx_reversal_transfer_in_fee: '换汇撤销转入手续费',
  bill_details: '账单详情',
  split_receiver: '分账接收方',
  split_transaction_no: '分账交易编号',
  split_detail_transaction_no: '分账明细编号',
  split_merchant_no_or_name: '出资商户编号/名称',
  receiver_type: '接收方类型',
  receiver_account: '接收方账号',
  transaction_no: '收款交易编号',
  split_merchant: '出资商户',
  receiver_name: '接收方名称',
  split_amount: '分账金额',
  receiver_relation: '与接收方的关系',
  relation_document: '关系证明文件',
  add_receiver: '添加分账接收方',
  edit_receiver: '编辑分账接收方',
  split_transaction_detail: '分账交易详情',
  customize: '自定义关系',
  uploaded: '已上传',
  not_uploaded: '未上传',
  account_location: '银行账户归属地',
  account_location_local: '本地',
  account_location_overseas: '海外',
  bank_address: '银行地址',
  swift_code: 'SWIFT',
  bank_wallet_tooltip: '需要包含:银行账号、账户名称、银行名称',
  currency_required: '币种不能为空',
  account_location_required: '银行账户归属地不能为空',
  bank_address_required: '请填写银行地址',
  swift_code_required: '请填写SWIFT',
  bank_account_proof: '银行账户证明文件',
  invoice_image: '发票',
  nick_name: '备注名',
  withdrawal_amount: '提现金额',
  amount_received: '到账金额',
  refresh_exchange_rate: '重新获取汇率',
  refresh_exchange_rate_after: '{time}后重新获取',
  withdraw_information_confirmation: '提现信息确认',
  confirm_cash_out_title: '确认',
  confirm_cash_out_message: '您确定要确认此次提现吗？',
  confirm_cash_out_btn: '确认',
  cancel_cash_out_btn: '取消',
  withdraw_currency: '提现币种',
  arrive_currency: '到账币种',
  fee_currency: '服务费币种',
  card_verification_count: '验卡笔数',
  card_verification_fee: '验卡手续费',
  card_verification_failed_fee_refund: '验卡失败手续费退款',
  card_verification_list: '验卡列表',
  card_verification_details: '验卡详情',
  card_verification_info: '验卡信息',
  basic_info: '基本信息',
  time_info: '时间信息',
  recipient_name: '收款人名称',
  bank_wallet_name: '银行钱包名称',
  verification_type: '验卡类型',
  cardholder_real_name: '持卡人真实姓名',
  transaction_id: '交易编号',
  merchant_order_id: '商户订单号',
  account_no: '账号',
  account_bank_code: '账户银行代码',
  account_name: '账户名',
  account_status: '卡号状态',
  order_status: '订单状态',
  failed_message: '验卡错误信息',
  name_match_result: '姓名匹配状态',
  account_type: '账号类型',
  institute_transaction_id: '机构交易号',
  institute_name: '机构名称',
  channel_name: '渠道名称',
  validation_amount: '验证金额',
  validation_currency: '验证币种',
  fee_split: '分润金额',
  fee_split_currency: '分润币种',
  account_validate_result: '账号验证结果',
  transaction_status: '交易状态',
  card_verifying: '验卡中',
  card_verification_success: '验卡成功',
  card_verification_failed: '验卡失败',
  card_verification_cost: '验卡费用',
  // 账户类型
  account_type_bank: 'BANK',
  account_type_va: 'VA',
  account_type_ewallet: 'EWALLET',
  account_type_unknown: 'UNKNOWN',
  // 失败信息
  failure_message: '失败信息',
  // 账号真实KYC状态
  account_kyc_result: '账号真实KYC状态',
  // 账户姓名匹配结果标签
  account_name_match: 'MATCH',
  account_name_not_match: 'NOT_MATCH',
  account_name_unknown: 'UNKNOWN',
  // 账户验证结果标签
  account_validate_valid: 'VALID',
  account_validate_invalid: 'INVALID',
  account_validate_unknown: 'UNKNOWN',
  status_pending: '待处理',
  status_success: '成功',
  status_failed: '失败',
  account_actual_type: '账号真实类型',
  pos_machine_sn: '刷卡机SN序列号'
}
